export default function padNumber(num) {
  return ('0' + num).slice(-2);
}